import React, { useState, useEffect, useRef, JSX } from 'react';
import AutoComplete from './AutoComplete';
import { IndividualLineCheck } from './IndividualLineCheck';
import { ERRORMESSAGE, ERRORTYPE, FIXNET } from '../../Analytics/AnalyticsConstants';
import { viewport } from '../../utils/utils';
import { trackErrorEvent, trackMessageEvent } from '../../utils/AnalyticsUtils';
import { fetchAddress } from './LinecheckService';
import Styles from './LineCheckInput.module.scss';
interface Address {
  cantonCode: string;
  city: string;
  houseNumber: string;
  postCode: string;
  street: string;
  concatedAddress: string;
}
const LineCheckInput = React.forwardRef<HTMLInputElement, any>(
  ({
    content,
    parentCallback,
    parentAddress,
    isAddressNotFilled,
    onChange,
    name,
    apiError,
    setApiError,
    setFetchingLineCheck,
    checkAvailability,
    onData,
    FetchingLineCheck,
    setSelectedAddress,
    ref,
    Address,
    setIndivialOpen,
    indivialOpen,
    setAddressNotFilled
  }): JSX.Element => {
    const [addressNotFound, setaddressNotFound] = useState<boolean>(false);
    const [addresserr, setAddresserr] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [addressFromParent, setAddressFromParent] = useState<string>('');
    const [data, setData] = useState<any>();
    const [openIndividualLineCheck, setOpenIndividualLineCheck] = useState(false);
    const controllerRef=useRef<AbortController | null>(null);
    const viewPort = viewport();
    const selectedAddress = (data: Address) => {
      typeof setAddressFromParent === 'function' && setAddressFromParent(data.concatedAddress);
      typeof parentCallback === 'function' &&
        parentCallback(data, {
          openIndividualLineCheck: false,
          availabilityCheckClicked: false
        });
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (typeof onChange == 'function') onChange(e);
      typeof setAddressFromParent === 'function' && setAddressFromParent(e?.currentTarget?.value);
      let notValidAddress: boolean = false;
      notValidAddress = new RegExp(`[${content?.regexp}]`).test(e?.currentTarget?.value);
      setAddresserr(notValidAddress);
      const value = e?.currentTarget?.value;
      fetchAddress(value, notValidAddress,controllerRef)
        .then((res: any) => {
          if ((res && res?.error) || res?.length <= 0) {
            setData([]);
            setaddressNotFound(true);
          } else {
            setData(res);
            setaddressNotFound(false);
          }
        })
        .catch((err: any) =>
          // eslint-disable-next-line no-console
          console.log(err)
        );
    };
    useEffect(() => {
      if (addressNotFound && addressFromParent) {
        // setErrorMessage(content.noAddressFoundErrorMsg);
        if (name === 'differentAddress') {
          typeof parentCallback === 'function' && parentCallback({});
        }
      } else {
        setErrorMessage('');
      }
    }, [addressFromParent, addressNotFound]);
    useEffect(() => {
      typeof setAddressFromParent === 'function' && setAddressFromParent(parentAddress);
    }, []);
    //tracking linkcheck error message
    useEffect(() => {
      addresserr &&
        trackMessageEvent(
          content?.errorMsg,
          FIXNET + ' ' + content?.title,
          ERRORMESSAGE,
          ERRORTYPE
        );
      !addressFromParent &&
        isAddressNotFilled &&
        trackMessageEvent(
          content?.requiredFieldText,
          FIXNET + ' ' + content?.title,
          ERRORMESSAGE,
          ERRORTYPE
        );
      errorMessage &&
        trackMessageEvent(errorMessage, FIXNET + ' ' + content?.title, ERRORMESSAGE, ERRORTYPE);
      addresserr &&
        trackErrorEvent(
          ERRORTYPE,
          ERRORMESSAGE,
          FIXNET + ' | ' + content?.title,
          content?.errorMsg
        );
      !addressFromParent &&
        isAddressNotFilled &&
        trackErrorEvent(
          ERRORTYPE,
          ERRORMESSAGE,
          FIXNET + ' | ' + content?.title,
          content?.requiredFieldText
        );
      errorMessage &&
        trackErrorEvent(ERRORTYPE, ERRORMESSAGE, FIXNET + ' | ' + content?.title, errorMessage);
    }, [addresserr, isAddressNotFilled, errorMessage]);
    const addressForIndividual = (data: any, clicked: boolean) => {
      if (
        data?.postCode !== '' &&
        data.city !== '' &&
        data.houseNumber !== '' &&
        data.street !== '' &&
        data.concatedAddress !== ''
      ) {
        typeof parentCallback === 'function' &&
          parentCallback(data, {
            openIndividualLineCheck: openIndividualLineCheck,
            availabilityCheckClicked: clicked
          });
      }
    };
    useEffect(()=>{
      if(apiError){
        typeof setOpenIndividualLineCheck === 'function' &&setOpenIndividualLineCheck(true) ;
        typeof setIndivialOpen === 'function' && setIndivialOpen({...indivialOpen,indOpen: true })
        if(viewPort==='mobile' && openIndividualLineCheck){
          typeof setIndivialOpen === 'function' && setIndivialOpen({...indivialOpen,indErrorOpen: true })
        }
      }
  
      },[apiError]); 

    useEffect(()=>{
      if(openIndividualLineCheck && !addressNotFound){
        typeof setIndivialOpen === 'function' && setIndivialOpen({...indivialOpen,indErrorOpen: true })
      }
    },[openIndividualLineCheck,addressNotFound])

    return (
      <>
        {!openIndividualLineCheck && (
          <AutoComplete
            inputValue={addressFromParent || ''}
            setInputValue={setAddressFromParent}
            dropdownValue={data}
            placeholder={content?.placeholder}
            ref={ref}
            onChange={handleChange}
            selectedData={selectedAddress}
            inputClassName={`${isAddressNotFilled ? Styles['errorfield'] : ''} ${
              !(FetchingLineCheck || checkAvailability) ? Styles['checking'] : ''
            } ${Styles['truncation']} form-control  `}
            minLength={content?.linecheckMinLength}
            maxLength={content?.linecheckMaxLength}
            name={name}
            content={content}
            addressNotFound={addressNotFound}
            setApiError={setApiError}
            setFetchingLineCheck={setFetchingLineCheck}
            checkAvailability={checkAvailability}
            FetchingLineCheck={FetchingLineCheck}
            setaddressNotFound={setaddressNotFound}
          />
        )}

        {addresserr && <p className={Styles['errormsg']}>{content?.errorMsg}</p>}
        <div className={Styles['address']}>
          {!addressFromParent && isAddressNotFilled && (
            <p className={Styles['errormsg']}>
              <img
                src={content?.linecheckIcons?.[0]?.warning?.filename}
                height='12px'
                width='16px'
                alt={'alert'}
              />
              {content?.requiredFieldText}
            </p>
          )}
        </div>
        {apiError && viewPort == 'mobile' && !openIndividualLineCheck && !FetchingLineCheck && (

          <p
            className={Styles['secondarybutton-mobile']}
            onClick={() => {
              typeof setOpenIndividualLineCheck === 'function' && setOpenIndividualLineCheck(true)
              typeof setIndivialOpen === 'function' &&  setIndivialOpen({...indivialOpen,indOpen: true })
            }}
          >
            {content?.noAddress}
            <span>
              <img src={content?.arrowIcon?.filename} height={24} width={24} alt='right-arrow' />
            </span>
          </p>
        )}

        {addressNotFound && !openIndividualLineCheck && !FetchingLineCheck && (
          <div>
            {viewPort === 'mobile' && (
              <p
                className={Styles['secondarybutton-mobile']}
                onClick={() => {
              typeof setOpenIndividualLineCheck === 'function' && setOpenIndividualLineCheck(true)
              typeof setIndivialOpen === 'function' &&  setIndivialOpen({...indivialOpen,indOpen: true })
                }}
              >
                {content?.noAddress}
                <span>
                  <img
                    src={content?.arrowIcon?.filename}
                    height={24}
                    width={24}
                    alt='right-arrow'
                  />
                </span>
              </p>
            )}
          </div>
        )}
        {openIndividualLineCheck && (
          <IndividualLineCheck
            parentCallBackIndividual={addressForIndividual}
            content={content}
            apiError={apiError}
            setApiError={setApiError}
            setFetchingLineCheck={setFetchingLineCheck}
            setSelectedAddress={setSelectedAddress}
            openIndividualLineCheck={openIndividualLineCheck}
            FetchingLineCheck={FetchingLineCheck}
            addressRef={ref}
            selected={Address}
            addressNotFound={addressNotFound}
            setaddressNotFound={setaddressNotFound}
            isAddressNotFilled={isAddressNotFilled}
            setAddressNotFilled={setAddressNotFilled}
            setIndivialOpen={setIndivialOpen}
          />       
              )}
        {  ((addressNotFound && !openIndividualLineCheck) || (!FetchingLineCheck && !addressNotFound && openIndividualLineCheck)) && viewPort != 'mobile' && (
         <>
         { !(!FetchingLineCheck && !addressNotFound && openIndividualLineCheck) && (
          <div className={Styles['ul-disabled']}>
            <p
              className={`${Styles['secondarybutton']} ${Styles['list']} `}
              onClick={() => {
              typeof setOpenIndividualLineCheck === 'function' && setOpenIndividualLineCheck(true)
              typeof setIndivialOpen === 'function' && setIndivialOpen({...indivialOpen,indOpen: true })
              }}
            >
              {content?.noAddress}
              <span>
                <img src={content?.arrowIcon?.filename} height={24} width={24} alt='right-arrow' />
              </span>
            </p>
          </div>
         )
      }   
  </>
        )}
      </>
    );
  }
);

export default LineCheckInput;
